import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirm-logout',
  templateUrl: './modal-confirm-logout.component.html',
  styleUrls: ['./modal-confirm-logout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalConfirmLogoutComponent implements OnInit {

  constructor(
    private ngbActiveModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

  public closeModal(result: boolean): void {
    this.ngbActiveModal.close(result);
  }
}
